import { shallowEqual } from 'react-redux';

import { Box } from '@zillow/constellation-10';

import { useSelector } from '../../../../selectors/useSelector';

import accessUtils from '../../../../utils/accessUtils';

import SFCostAndFeesTotalMonthlyPriceWithFeeAlert from '../../../Alerts/SFCostAndFeesTotalMonthlyPriceWithFeeAlert';
import SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert from '../../../Alerts/SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert';
import CostsAndFeesFormField from '../../CostsAndFees/components/CostsAndFeesFormField';

const CostsAndFeesContent = () => {
  const { cookieEnabledServices, isOptInTotalMonthlyPriceWithFeeEligible, isTotalMonthlyPriceWithFeeEligible } =
    useSelector(
      (state) => ({
        cookieEnabledServices: state.app.cookieEnabledServices,
        isOptInTotalMonthlyPriceWithFeeEligible:
          state.properties.currentProperty?.totalMonthlyPriceWithFee.isOptInEligible,
        isTotalMonthlyPriceWithFeeEligible:
          state.properties.currentProperty?.totalMonthlyPriceWithFeeNotice?.isEligible,
      }),
      shallowEqual,
    );

  const canAccessTotalMonthlyPriceWithFee = accessUtils.canAccessTotalMonthlyPriceWithFee({
    cookieEnabledServices,
    isEligible: isTotalMonthlyPriceWithFeeEligible,
  });

  return (
    <div data-testid="CostsAndFeesContent" data-group-title="CostsAndFees">
      {canAccessTotalMonthlyPriceWithFee && <SFCostAndFeesTotalMonthlyPriceWithFeeAlert />}
      {isOptInTotalMonthlyPriceWithFeeEligible && <SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert />}

      <Box data-testid="CostsAndFeesReviewSection">
        <CostsAndFeesFormField displayedLocation="posting_path_review" />
      </Box>
    </div>
  );
};

export default CostsAndFeesContent;
